import { Container } from './styles'

interface iOutlineBox{
  width?: string
  margin?: string
  borderColor?: string
  style?: any
}

export const OutlineBox: React.FC<iOutlineBox> = ({ children, width, margin, borderColor, style }) => {
  return (
        <Container
          margin={margin}
          width={width}
          borderColor={borderColor}
          style={style}
        >{children}</Container>
  )
}
